import { render } from "./Lakip.vue?vue&type=template&id=19639134"
import script from "./Lakip.vue?vue&type=script&lang=js"
export * from "./Lakip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__